import 'types/ace.d';

const ACE_SCRIPT_ID = 'ace-widget-script';

const ACE_SCRIPT_URL = process.env.REACT_APP_ACE_SCRIPT_URL;
export const ACE_SUBDOMAIN = process.env.REACT_APP_ACE_SUBDOMAIN;
export const ACE_WSUUID = process.env.REACT_APP_ACE_WSUUID;

const ACE_MEETING_LINKS: Record<string, string | undefined> = {
  en: process.env.REACT_APP_ACE_MEETING_LINK_EN,
  de: process.env.REACT_APP_ACE_MEETING_LINK_DE,
};

export const getAceMeetingLink = (locale: string): string | undefined =>
  ACE_MEETING_LINKS[locale] ?? ACE_MEETING_LINKS.en;

let loadPromise: Promise<void> | null = null;

export const loadAceWidget = (): Promise<void> => {
  if (loadPromise) {
    return loadPromise;
  }
  if (!ACE_SCRIPT_URL) {
    return Promise.reject(new Error('REACT_APP_ACE_SCRIPT_URL is not set'));
  }

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = ACE_SCRIPT_ID;
    script.src = ACE_SCRIPT_URL;
    script.type = 'module';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      script.remove();
      loadPromise = null;
      reject(new Error('ACE widget script failed to load'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};
